import { address } from "faker/lib/locales/az";
import React from "react";

const labelTranslations = {
  name: "Emri",
  phoneNumber: "Numri Telefonit",
  address: "Adresa",
  email: "Emaili",
  oshma: "Oshma",
  id: "ID",
  legalForm: "Emri Subjektit",
  CABLE: "Kabllore",
  RADIO: "OSHMA Audio",
  TV: "OSHMA Audiovizive",
  OTHER: "Shërbimet e tjera",
  // Shto përkthime shtesë sipas nevojës...
};

const ModelViewListOshma = ({
  tableContent = [],
  customHeader = [],
  customFooter = [],
  excludedColumns = [],
}) => {
  if (!Array.isArray(tableContent) || tableContent.length === 0) {
    return <p>No data available</p>;
  }
  excludedColumns = ["id", "createdAt", "updatedAt"];
  const columnOrder = ["legalForm", "address", "phoneNumber", "email"]; // Renditja që do

  // Grupi sipas `type`
  const groupedByType = tableContent.reduce((acc, item) => {
    const type = item.type || "Tjetër";
    if (!acc[type]) acc[type] = [];
    acc[type].push(item);
    return acc;
  }, {});

  // Për secilin grup, krijo tabelën
  return (
    <>
      {Object.entries(groupedByType).map(([type, items]) => {
        // Ekstraho çelësat valid
        const extractValidKeys = (data) => {
          const keys = new Set();
          data.forEach((item) => {
            Object.entries(item).forEach(([key, value]) => {
              const isExcluded =
                excludedColumns.includes(key) || key === "type";
              const isValid = typeof value !== "object" || value === null;
              if (!isExcluded && isValid) {
                keys.add(key);
              }
            });
          });
          return Array.from(keys);
        };

        // Përdor rendin e kërkuar për kolonat
        const validKeys = extractValidKeys(items);
        const orderedKeys = columnOrder.filter((key) =>
          validKeys.includes(key)
        );

        return (
          <div key={type} style={{ marginBottom: "40px" }}>
            <h3 style={{ textTransform: "capitalize", margin: "20px 0 10px" }}>
              {labelTranslations[type] || type}
            </h3>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "center",
              }}
            >
              {/* Custom Header */}
              {customHeader.length > 0 && (
                <thead>
                  {customHeader.map((headerRow, index) => (
                    <tr
                      key={index}
                      style={{ backgroundColor: "#ED1D25", color: "#fff" }}
                    >
                      {Object.values(headerRow).map((cell, idx) => (
                        <th
                          key={idx}
                          style={{ padding: "10px", border: "1px solid #fff" }}
                        >
                          {cell}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
              )}

              {/* Table Header */}
              <thead>
                <tr style={{ backgroundColor: "#ED1D25", color: "#fff" }}>
                  <td rowspan="2">EMRI I SUBJEKTIT (OSHMA) </td>
                  <td colspan="3">KONTAKTE</td>
                </tr>
                <tr style={{ backgroundColor: "#ED1D25", color: "#fff" }}>
                  <th style={{ padding: "10px", border: "1px solid #fff" }}>
                    <td>ADRESA</td>
                  </th>
                  <th style={{ padding: "10px", border: "1px solid #fff" }}>
                    <td>TLEFONI</td>
                  </th>
                  <th style={{ padding: "10px", border: "1px solid #fff" }}>
                    <td>E-MAIL</td>
                  </th>
                </tr>
              </thead>

              {/* Table Content */}
              <tbody>
                {items.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {orderedKeys.map((key, cellIndex) => (
                      <td
                        key={cellIndex}
                        style={{
                          padding: "10px",
                          border: "1px solid #000",
                          backgroundColor:
                            key === "oshma"
                              ? "#ffa2a2"
                              : key === "emaili"
                              ? "#c0deff"
                              : "transparent",
                        }}
                      >
                        {row[key] ?? ""}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>

              {/* Custom Footer */}
              {customFooter.length > 0 && (
                <tfoot>
                  {customFooter.map((footerRow, index) => (
                    <tr
                      key={index}
                      style={{ backgroundColor: "#f44336", color: "#fff" }}
                    >
                      {Object.values(footerRow).map((cell, idx) => (
                        <td
                          key={idx}
                          style={{ padding: "10px", border: "1px solid #fff" }}
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tfoot>
              )}
            </table>
          </div>
        );
      })}
    </>
  );
};

export default ModelViewListOshma;
